<template>
  <div>
    <el-form :model="formInline" class="demo-form-inline" :rules="rules">
      <el-form-item label="姓名" prop="name">
        <el-input v-model="formInline.name" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input v-model="formInline.phone" placeholder="电话"></el-input>
      </el-form-item>
      <el-form-item label="探头序列号" prop="probeSn">
        <el-input v-model="formInline.probeSn" placeholder="探头序列号"></el-input>
      </el-form-item>
      <el-form-item label="探头型号" prop="probeType">
        <el-input v-model="formInline.probeType" placeholder="探头型号"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "ReleaseReviewInfo",
  watch: {
    'formInline.name'() {
      this.sendInfoData();
    },
    'formInline.phone'() {
      this.sendInfoData();
    },
    'formInline.probeSn'() {
      this.sendInfoData();
    },
    'formInline.probeType'() {
      this.sendInfoData();
    }
  },
  data() {
    return {
      formInline: {
        name: '',
        phone: '',
        probeSn: '',
        probeType: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入您的名字',
          trigger: 'blur'
        },
          {
            min: 2,
            max: 8,
            message: '最多8个字符',
            trigger: 'blur'
          }
        ],
        phone: [{
          required: true,
          message: '请输入您的电话号码',
          trigger: 'blur'
        },
          {
            max: 11,
            message: '最多11个数字',
            trigger: 'blur'
          }
        ],
        probeSn: [{
          required: true,
          message: '请输入探头序列号',
          trigger: 'blur'
        },
          {
            max: 16,
            message: '最多16个字符',
            trigger: 'blur'
          }
        ],
        probeType: [{
          required: true,
          message: '请输入您的名字',
          trigger: 'blur'
        },
          {
            max: 8,
            message: '最多8个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    // 输入框内容改变的时候发送给父组件
    sendInfoData() {
      this.$emit('getInfoData', this.formInline);
    },
  }
}
</script>

<style scoped>
  .demo-form-inline {
    max-width: 300px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/release_review/ReleaseReviewInfo.vue